import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation, matchPath } from "react-router-dom";
import { Navbar, Sidebar, Footer, LoadingMessage } from "../components";
import { useStateContext } from "../contexts/ContextProvider";

import { Breadcrumb, Layout, Menu, Button, Divider } from "antd";
import { ArrowsAltOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { TbCirclesRelation } from "react-icons/tb";
import { BsSunFill, BsMoonFill } from "react-icons/bs";
import { MdOutlineInventory2, MdLocationCity } from "react-icons/md";
import { FaRegIdCard, FaCartShopping } from "react-icons/fa6";
import { CiRoute, CiDeliveryTruck } from "react-icons/ci";
import { TbTruckDelivery } from "react-icons/tb";
import { PiSignOutBold } from "react-icons/pi";
import { IoIosHelpCircle } from "react-icons/io";
import { FiShoppingBag } from "react-icons/fi";
import { RiTableAltFill } from "react-icons/ri";
import { MdPriceChange } from "react-icons/md";
import { PiArrowSquareDownRightFill } from "react-icons/pi";

import {
  RiShoppingCart2Fill,
  RiShoppingCart2Line,
  RiContactsFill,
  RiContactsLine,
} from "react-icons/ri";

import { FaRegUser, FaUser } from "react-icons/fa";

import {
  HiArchiveBox,
  HiOutlineArchiveBox,
  HiCube,
  HiOutlineCube,
} from "react-icons/hi2";

import { PiSteeringWheelFill, PiSteeringWheel } from "react-icons/pi";

import {
  TbLayoutSidebarRightCollapseFilled,
  TbLayoutSidebarRightExpandFilled,
} from "react-icons/tb";

import isotipo from "../data/Isotipo.png";
import {
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";

import { useAuth } from "../contexts/AuthProvider";
import { hasPermission } from "../utils/auth";

const { Header, Content, Sider } = Layout;

const breadcrumbMap = {
  "/": [{ name: "Menú Principal", link: "/" }],
  "/home": [{ name: "Menú Principal", link: "/" }],
  "/orders": [
    { name: "Menú Principal", link: "/" },
    { name: "Pedidos", link: "/orders" },
  ],
  "/orders/:id": [
    { name: "Menú Principal", link: "/" },
    { name: "Pedidos", link: "/orders" },
    { name: "Detalle de Pedido" },
  ],
  "/products": [
    { name: "Menú Principal", link: "/" },
    { name: "Productos", link: "/products" },
  ],
  "/products/:product_id": [
    { name: "Menú Principal", link: "/" },
    { name: "Productos", link: "/products" },
    { name: "Detalle de Producto" },
  ],
  "/products/create": [
    { name: "Menú Principal", link: "/" },
    { name: "Productos", link: "/products" },
    { name: "Creación de Producto" },
  ],
  "/sellers": [
    { name: "Menú Principal", link: "/" },
    { name: "Vendedores", link: "/sellers" },
  ],
  "/clients": [
    { name: "Menú Principal", link: "/" },
    { name: "Clientes", link: "/clients" },
  ],
  "/drivers": [
    { name: "Menú Principal", link: "/" },
    { name: "Choferes", link: "/drivers" },
  ],
  "/cities": [
    { name: "Menú Principal", link: "/" },
    { name: "Ciudades", link: "/cities" },
  ],
  "/makeroute": [
    { name: "Menú Principal", link: "/" },
    { name: "Hacer Ruta", link: "/makeroute" },
  ],
  "/checkprices": [
    { name: "Menú Principal", link: "/" },
    { name: "Revisar Precios", link: "/checkprices" },
  ],
  "/reschedule": [
    { name: "Menú Principal", link: "/" },
    { name: "Reagendar", link: "/reschedule" },
  ],
  "/dashboardDailyRoute": [
    { name: "Menú Principal", link: "/" },
    { name: "Ruta Diaria" },
  ],
  "/dashboardDailyRoute/:routeDay": [
    { name: "Menú Principal", link: "/" },
    { name: "Ruta Diaria", link: "/dashboardDailyRoute" },
    { name: "Dashboard" },
  ],
  "/route-monitoring": [
    { name: "Menú Principal", link: "/" },
    { name: "Monitoreo de Rutas" },
  ],
  "/route-monitoring/:routeDay": [
    { name: "Menú Principal", link: "/" },
    { name: "Monitoreo de Rutas", link: "/route-monitoring" },
    { name: "Dashboard" },
  ],
  "/reports": [
    { name: "Menú Principal", link: "/" },
    { name: "Reportes", link: "/reports" },
  ],
  "/reports/:report_id": [
    { name: "Menú Principal", link: "/" },
    { name: "Reportes", link: "/reports" },
    { name: "Detalle de Reporte" },
  ],
  "/generalconfig": [
    { name: "Menú Principal", link: "/" },
    { name: "Configuración General", link: "/generalconfig" },
  ],
  "/format-suggestions": [
    { name: "Menú Principal", link: "/" },
    { name: "Formato Map", link: "/format-suggestions" },
  ],
  "/accounts": [
    { name: "Menú Principal", link: "/" },
    { name: "Cuentas y Roles", link: "/accounts" },
  ],
  "/notFoundPage": [{ name: "404", link: "/notFoundPage" }],
};

// Mirrors the route paths declared in App.js, most specific first, so a
// dynamic path (e.g. /dashboardDailyRoute/2026-07-24) resolves to the
// matching breadcrumbMap entry regardless of the param's format (numeric
// id, date string, etc).
const routePatterns = Object.keys(breadcrumbMap);

const links = [
  {
    title: "Home",
    spaTitle: "Home",
    links: [
      {
        name: "home",
        spaName: "Menú Principal",
        icon: <FiShoppingBag />,
      },
    ],
  },

  {
    title: "Pages",
    spaTitle: "Páginas",
    links: [
      {
        name: "orders",
        spaName: "Pedidos",
        icon: <HiArchiveBox />,
        permission: "orders:read",
      },
      {
        name: "products",
        spaName: "Productos",
        icon: <HiCube />,
        permission: "products:read",
      },
      {
        name: "cities",
        spaName: "Ciudades",
        icon: <MdLocationCity />,
        permission: "cities:read",
      },
    ],
  },
  {
    title: "Monitoring",
    spaTitle: "Monitoreo",
    links: [
      {
        name: "dashboardDailyRoute",
        spaName: "Ruta Diaria",
        icon: <CiDeliveryTruck />,
        permission: "orders:read",
      },
      {
        name: "route-monitoring",
        spaName: "Monitoreo",
        icon: <TbTruckDelivery />,
      },
      {
        name: "reports",
        spaName: "Reportes",
        icon: <RiTableAltFill />,
        permission: "reports:read",
      },
    ],
  },
  {
    title: "Tools",
    spaTitle: "Herramientas",
    collapsible: true,
    links: [
      {
        name: "makeroute",
        spaName: "Hacer Ruta",
        icon: <CiRoute />,
        permission: "orders:write",
      },
      {
        name: "checkprices",
        spaName: "Revisar Precios",
        icon: <MdPriceChange />,
        permission: "orders:write",
      },
      {
        name: "reschedule",
        spaName: "Reagendar",
        icon: <PiArrowSquareDownRightFill />,
        permission: "orders:write",
      },
      {
        name: "format-suggestions",
        spaName: "Formato Map",
        icon: <TbCirclesRelation />,
        permission: "orders:read",
      },
    ],
  },
];

const sizeIconsSmallDevices = "w-4 h-4";

const linksSmallDevices = [
  {
    name: "orders",
    spaName: "Pedidos",
    iconInactive: <HiOutlineArchiveBox className="w-5 h-5" />,
    iconActive: <HiArchiveBox className="w-5 h-5" />,
    permission: "orders:read",
  },
  {
    name: "products",
    spaName: "Productos",
    iconInactive: <HiOutlineCube className={sizeIconsSmallDevices} />,
    iconActive: <HiCube className={sizeIconsSmallDevices} />,
    permission: "products:read",
  },
  {
    name: "sellers",
    spaName: "Vendedores",
    iconInactive: <RiContactsLine className={sizeIconsSmallDevices} />,
    iconActive: <RiContactsFill className={sizeIconsSmallDevices} />,
    permission: "personnel:read",
  },
  {
    name: "clients",
    spaName: "Clientes",
    iconInactive: <FaRegUser className={sizeIconsSmallDevices} />,
    iconActive: <FaUser className={sizeIconsSmallDevices} />,
  },
  {
    name: "drivers",
    spaName: "Choferes",
    iconInactive: <PiSteeringWheel className="w-5 h-5" />,
    iconActive: <PiSteeringWheelFill className="w-5 h-5" />,
    permission: "personnel:read",
  },
];

const DashboardLayout = ({ children }) => {
  const { activeMenu, loadingMessage, darkMode, toggleDarkMode } = useStateContext();
  const [isSideBarCollaped, setIsSideBarCollaped] = useState(false);
  const { user } = useAuth();
  const canManageAccounts = hasPermission(user?.permissions, "users:write");
  // "permissions:write" is only ever granted to the superadmin role, so it
  // doubles as the superadmin check for gating the Configuración link.
  const canViewConfig = hasPermission(user?.permissions, "permissions:write");

  const handleClickSideBarCollapsed = () => {
    setIsSideBarCollaped(!isSideBarCollaped);
  };

  const location = useLocation();
  const path = location.pathname;

  const [openGroups, setOpenGroups] = useState({});
  const toggleGroup = (title) =>
    setOpenGroups((prev) => ({ ...prev, [title]: !prev[title] }));

  // Auto-expand a collapsible group when landing directly on one of its links
  // (e.g. via a bookmark), so the active item isn't hidden behind a toggle.
  useEffect(() => {
    const activeGroup = links.find(
      (item) =>
        item.collapsible &&
        item.links.some((link) => path.startsWith(`/${link.name}`)),
    );
    if (activeGroup) {
      setOpenGroups((prev) => ({ ...prev, [activeGroup.title]: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  // Find the route pattern (static or dynamic, e.g. "/orders/:id") that
  // matches the current path, regardless of the dynamic segment's format.
  const matchedPattern = routePatterns.find((pattern) =>
    matchPath({ path: pattern, end: true }, path),
  );

  // Get the breadcrumb items for the current path
  const breadcrumbItems = breadcrumbMap[matchedPattern] || [
    { name: "Menú Principal", link: "/" },
    { name: "No encontrado" },
  ];

  const borderRadius = "15";

  const items2 = links.map((item, index) => {
    const key = String(index + 1);

    return {
      key: key,
      label: item.spaTitle,
      children: item.links.map((link, index) => {
        return (
          <Menu.Item icon={link.icon}>
            <Link to={`/${link.name}`}>{link.spaName}</Link>
          </Menu.Item>
        );
      }),
    };
  });

  return (
    // <div className="flex relative dark:bg-main-dark-bg">
    //   <div
    //     className={
    //       activeMenu
    //         ? "w-72 block fixed sidebar bg-white transition-all duration-250 ease-in-out"
    //         : "w-0"
    //     }
    //     style={{ zIndex: "1000" }}
    //   >
    //     <Sidebar />
    //   </div>
    //   <div
    //     className={`dark:bg-main-bg bg-main-bg min-h-screen w-full transition-all duration-250 ease-in-out ${
    //       activeMenu ? "lg:ml-72 lg:w-[calc(100%-18rem)]" : "flex-2"
    //     }`}
    //   >
    //     <div className="bg-main-bg dark:bg-main-dark-bg-nav w-full">
    //       <Navbar
    //         className={`${activeMenu ? "lg:w-[calc(100%-18rem)]" : "w-full"}`}
    //       />
    //       {loadingMessage && <LoadingMessage activeMenu={activeMenu} />}
    //     </div>
    //     <div>{children}</div>
    //     <Footer />
    //   </div>
    // </div>

    <Layout style={{ height: "100vh" }} className="sm:px-1 sm:py-3">
      <Content className="sm:px-5">
        <Layout
          style={{
            flex: 1,
            borderRadius: `${borderRadius}px ${borderRadius}px ${borderRadius}px ${borderRadius}px`,
          }}
        >
          <div className="bg-transparent flex">
            {/* NavBar smalldevices */}
            <div
              className="fixed bottom-0 left-0 w-full bg-red-white sm:hidden h-14 flex justify-between px-4 bg-white shadow-2xl"
              style={{ zIndex: 10000 }}
            >
              {linksSmallDevices
                .filter(
                  (item) =>
                    !item.permission ||
                    hasPermission(user?.permissions, item.permission),
                )
                .map((item) => (
                <NavLink
                  to={item.name}
                  className={({ isActive }) =>
                    `transition-all duration-200 ease-in-out flex items-center justify-center w-full m-3 rounded-lg flex-col text-slate-700 ${
                      isActive ? "   focus:text-slate-800" : "bg-transparent"
                    }`
                  }
                >
                  {({ isActive }) =>
                    isActive ? item.iconActive : item.iconInactive
                  }
                </NavLink>
              ))}
            </div>

            {/* Sidebar */}
            <div
              className={`hidden sm:flex sm:flex-col my-3 transition-all duration-300 ease-in-out ${
                isSideBarCollaped ? "w-14" : " w-44"
              } `}
            >
              <Link
                to="/home"
                className=" text-slate-900 text-lg font-bold sm:block hidden"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <div className="flex items-center space-x-2 text-center justify-start ml-3">
                  <img className="w-8 h-8 rounded-md" src={isotipo} />{" "}
                  <span
                    className={`transition-all duration-300 ease-in-out whitespace-nowrap ${
                      isSideBarCollaped ? "opacity-0" : "opcity-100"
                    }`}
                  >
                    Co-Business
                  </span>
                </div>
              </Link>
              <div
                className={`sm:flex hidden transition-all duration-100 ease-in-out justify-end rounded-lg space-x-2 items-center min-h-8 ${
                  isSideBarCollaped ? "px-2.5" : "mr-0"
                }`}
              >
                <Button
                  onClick={handleClickSideBarCollapsed}
                  type="link"
                  className="text-gray-400 text-xs p-0 m-0"
                >
                  <div className="flex items-center">
                    <div
                      className={`lg:whitespace-nowrap lg:transition-all lg:duration-100 lg:ease-in-out  ${
                        isSideBarCollaped ? "opacity-0 w-0" : "opacity-100 w-14"
                      }`}
                    >
                      Colapsar
                    </div>
                    {isSideBarCollaped ? (
                      <TbLayoutSidebarRightCollapseFilled className="w-5 h-5 " />
                    ) : (
                      <TbLayoutSidebarRightExpandFilled className="w-5 h-5 " />
                    )}
                  </div>
                </Button>
                <div
                  className={`transtion-all duration-300 ease-in-out flex items-center justify-between ${
                    isSideBarCollaped ? "opacity-0" : "opacity-100 "
                  }`}
                ></div>
              </div>
              <Divider className="sm:block hidden" />
              <div
                className="hidden sm:flex flex-col justify-between my-3 sm:h-[80.7vh] overflow-hidden"
                // style={{ height: "80.7vh" }}
              >
                <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
                  {links.map((item, i) => {
                    const visibleLinks = item.links.filter(
                      (link) =>
                        !link.permission ||
                        hasPermission(user?.permissions, link.permission),
                    );
                    if (visibleLinks.length === 0) return null;

                    const isGroupOpen = !item.collapsible || !!openGroups[item.title];

                    return (
                    <>
                      {item.title !== "Home" && (
                        item.collapsible ? (
                          <button
                            type="button"
                            onClick={() => toggleGroup(item.title)}
                            className="w-full transition-all duration-100 ease-in-out px-2 py-1 rounded-lg m-2 flex space-x-2 items-center min-h-8 hover:bg-white hover:text-gray-700 text-gray-400"
                          >
                            <div className="pl-1">
                              <ToolOutlined />
                            </div>
                            <div className="flex items-center space-x-1.5 whitespace-nowrap">
                              <div
                                className={`transtion-all duration-100 ease-in-out ${
                                  isSideBarCollaped ? "opacity-0" : "opacity-100"
                                }`}
                              >
                                {item.spaTitle}
                              </div>
                              <div
                                className={`transtion-all duration-100 ease-in-out ${
                                  isSideBarCollaped ? "opacity-0" : "opacity-100"
                                }`}
                              >
                                {isGroupOpen ? <DownOutlined /> : <RightOutlined />}
                              </div>
                            </div>
                          </button>
                        ) : (
                          <div
                            className={`text-gray-400 text-xs font-semibold uppercase px-3 pt-2 pb-1 transition-all duration-100 ease-in-out whitespace-nowrap ${
                              isSideBarCollaped ? "opacity-0" : "opacity-100"
                            }`}
                          >
                            {item.spaTitle}
                          </div>
                        )
                      )}
                      {isGroupOpen &&
                        visibleLinks.map((link, i) => (
                        <NavLink
                          to={link.name}
                          className={({ isActive }) =>
                            `transition-all duration-100 ease-in-out px-2 py-1 rounded-lg m-2 flex space-x-2 items-center min-h-8  ${
                              isActive
                                ? `
                         shadow-sm bg-white outline hover:text-slate-800 outline-gray-200 outline-1 font-bold text-slate-700 focus:outline-1 focus:outline-gray-200 focus:outline `
                                : "hover:bg-white hover:text-gray-700 text-gray-400 "
                            }}`
                          }
                        >
                          <div className="pl-1">{link.icon}</div>
                          <div>
                            <div
                              className={`transtion-all duration-100 ease-in-out flex items-center justify-between whitespace-nowrap ${
                                isSideBarCollaped ? "opacity-0" : "opacity-100 "
                              }`}
                            >
                              {link.spaName}
                            </div>
                            {/* Additional Information */}
                            {/* <div className="text-gray-400 font-normal text-xs">
                              {i == 1 && ""}
                            </div> */}
                          </div>
                        </NavLink>
                      ))}
                      {i !== links.length - 1 && (
                        <Divider className="sm:block hidden" />
                      )}
                    </>
                    );
                  })}
                </div>
                <div className="flex flex-col">
                  {canManageAccounts && (
                    <NavLink
                      to="/accounts"
                      className={({ isActive }) =>
                        `px-2 py-1 rounded-lg m-2 flex space-x-2 items-center text-gray-500 min-h-8 ${
                          isActive
                            ? `
                         shadow-sm bg-white outline hover:text-slate-800 outline-gray-200 outline-1 font-bold text-slate-700 focus:outline-1 focus:outline-gray-200 focus:outline `
                            : "hover:bg-white hover:text-gray-700 text-gray-400 "
                        }`
                      }
                    >
                      <div>
                        <TeamOutlined className="w-5 h-5" />
                      </div>
                      <div
                        className={`flex w-28 justify-between items-center  ${
                          isSideBarCollaped && "hidden"
                        }`}
                      >
                        <div>Cuentas y Roles</div>
                      </div>
                    </NavLink>
                  )}
                  {canViewConfig && (
                  <NavLink
                    to="/generalconfig"
                    className={({ isActive }) =>
                      `px-2 py-1 rounded-lg m-2 flex space-x-2 items-center text-gray-500 min-h-8 ${
                        isActive
                          ? `
                         shadow-sm bg-white outline hover:text-slate-800 outline-gray-200 outline-1 font-bold text-slate-700 focus:outline-1 focus:outline-gray-200 focus:outline `
                          : "hover:bg-white hover:text-gray-700 text-gray-400 "
                      }`
                    }
                  >
                    <div>
                      <SettingOutlined className="w-5 h-5" />
                    </div>
                    <div
                      className={`flex w-28 justify-between items-center  ${
                        isSideBarCollaped && "hidden"
                      }`}
                    >
                      <div>Configuración</div>
                    </div>
                  </NavLink>
                  )}
                  <Button
                    onClick={() => {
                      localStorage.removeItem("token");
                      window.location.href = "/login";
                    }}
                  >
                    <PiSignOutBold />
                    <div className={isSideBarCollaped && "hidden"}>Salir</div>
                  </Button>
                </div>
              </div>
            </div>
            <Content
              className="overflow-y-auto py-1 px-2 sm:ml-2 sm:py-3 sm:px-6 bg-white dark:bg-secondary-dark-bg outline outline-gray-200 dark:outline-gray-700 h-[100vh] sm:h-[96vh] sm:rounded-xl"
              style={
                {
                  // height: "96vh",
                  // borderRadius: `${borderRadius}px ${borderRadius}px ${borderRadius}px ${borderRadius}px`,
                }
              }
            >
              <Header className="flex justify-between space-x-2 items-center p-0 min-h-8 bg-transparent">
                <div className="hidden sm:flex justify-start items-center overflow-hidden">
                  <Breadcrumb
                    className="text-sm"
                    items={breadcrumbItems.map((item) => ({
                      title: item.link ? (
                        <Link to={item.link}>{item.name}</Link>
                      ) : (
                        <span className="font-medium">{item.name}</span>
                      ),
                    }))}
                  />
                </div>

                {/* <div className="demo-logo" /> */}
                {/* <Menu
          className="w-full"
          mode="horizontal"
          defaultSelectedKeys={["1"]}
          items={items1}
          // style={{ flex: 1, minWidth: 0 }}
        /> */}
                <Button
                  type="text"
                  onClick={toggleDarkMode}
                  className="flex items-center justify-center"
                  icon={darkMode ? <BsSunFill className="text-yellow-400" /> : <BsMoonFill className="text-slate-500" />}
                />
              </Header>
              <div className="px-5 py-5">{children}</div>
            </Content>
          </div>
        </Layout>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        Created by Felipe Azúa Zagal.
      </Footer>
    </Layout>
  );
};

export default DashboardLayout;
